import truthConvert from "../utils/truth-convert";
export default function not() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  for (let arg of args) {
    if (truthConvert(arg) === true) {
      return false;
    }
  }
  return true;
}